export default __webpack_public_path__ + "static/media/MasterData.c1d36260.svg";